import { Component, Input, OnChanges } from '@angular/core';
import { AdminNavigationService, AdminSection } from '../services/admin-navigation.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-admin-section-nav',
  templateUrl: './admin-section-nav.component.html',
  styleUrls: ['./admin-section-nav.component.scss'],
})
export class AdminSectionNavComponent implements OnChanges {
  @Input() currentSection: AdminSection | '' = '';

  selectedNav = '';

  constructor(
    public userService: UserService,
    private adminNavigation: AdminNavigationService,
  ) {}

  ngOnChanges(): void {
    this.selectedNav = this.currentSection;
  }

  canAccessContactsSections(): boolean {
    return this.userService.hasElevatedPermissions() || this.userService.isSkuttAdmin();
  }

  onNavigationChange(event: { detail: { value: string } }): void {
    const value = event.detail.value;
    this.selectedNav = value;
    this.adminNavigation.navigate(value, this.currentSection || undefined);
  }
}
